import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { MissionsGetResponseBody } from "../common/type/type";
import dayjs from "dayjs";

interface MissionTableProps {
  rows: MissionsGetResponseBody;
  onRowClick: (link: string) => void;
}

export const MissionTable: React.FC<MissionTableProps> = ({
  rows,
  onRowClick,
}) => (
  <TableContainer
    component={Paper}
    sx={{
      margin: "0 auto",
      mt: 4,
      overflowX: "auto",
      height: "calc(100vh - 300px)",
    }}
  >
    <Table
      size="medium"
      sx={{ minWidth: 650, tableLayout: "fixed" }}
      aria-label="simple table"
    >
      <TableHead>
        <TableRow sx={{ height: "40px", width: "100%" }}>
          <TableCell>ミッション名</TableCell>
          <TableCell sx={{ borderLeft: "1px solid #e0e0e0" }}>
            ミッションタイプ
          </TableCell>
          <TableCell sx={{ borderLeft: "1px solid #e0e0e0" }}>
            配信期間
          </TableCell>
          <TableCell sx={{ borderLeft: "1px solid #e0e0e0" }}>
            ポイント
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, index) => (
          <TableRow
            key={index}
            hover
            onClick={() => onRowClick(row.mission.id)}
            sx={{
              cursor: "pointer",
              "& td": { borderLeft: "1px solid #e0e0e0" },
            }}
          >
            <TableCell component="th" scope="row">
              {row.mission.title}
            </TableCell>
            <TableCell>{row.mission.missionType.text}</TableCell>
            {/* <TableCell>
              {row.mission.startedAt} ~ {row.mission.endedAt}
            </TableCell> */}
            <TableCell>
              {dayjs(row.mission.startedAt).format("YYYY-MM-DD HH:mm")} ~{" "}
              {row.mission.endedAt
                ? dayjs(row.mission.endedAt).format("YYYY-MM-DD HH:mm")
                : ""}
            </TableCell>

            <TableCell>{row.mission.point}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);
